module.exports = __webpack_public_path__ + "static/media/iphone 12 pro max banner5.aacb6aaa.jpg";